"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _BaseRenderer = _interopRequireDefault(require("./BaseRenderer"));

var _GroupRenderer2 = _interopRequireDefault(require("./GroupRenderer"));

var _LayerTransformData = _interopRequireDefault(require("../layers/LayerTransformData"));

var _Creative = _interopRequireDefault(require("../../models/creative/Creative"));

var _CreativeLayer = _interopRequireDefault(require("../../models/creative/CreativeLayer"));

var _Rectangle = _interopRequireDefault(require("../../models/geometry/Rectangle"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _ContentStore = _interopRequireDefault(require("../store/ContentStore"));

var _creative = require("../../constants/creative");

var _LayerRendererCache = _interopRequireDefault(require("./cache/LayerRendererCache"));

var _ContextFilterProcessor = _interopRequireDefault(require("./filter/ContextFilterProcessor"));

var _LayerTransformer = _interopRequireDefault(require("./transform/LayerTransformer"));

var _setContextTransform = _interopRequireDefault(require("./transform/setContextTransform"));

var _canvas = require("../../utils/canvas");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RootRenderer = /*#__PURE__*/function (_GroupRenderer) {
  (0, _inherits2["default"])(RootRenderer, _GroupRenderer);

  var _super = _createSuper(RootRenderer);

  /**
   *
   * @param {Creative} creative
   * @param {ContentStore} contentStore
   * @param {CanvasFactory} canvasFactory
   * @param {{
   *   canvasDimensions: Rectangle,
   *   canvasImageSmoothing: Boolean,
   *   filterProcessor:FilterProcessor,
   *   layerRendererCache:LayerRendererCache,
   *   rootCanvas:HTMLCanvasElement
   * }} options
   */
  function RootRenderer(creative, contentStore, canvasFactory) {
    var _this;

    var renderOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, _classCallCheck2["default"])(this, RootRenderer);

    if (!_Creative["default"].isCreative(creative)) {
      throw new Error('creative must be of type Creative');
    }

    if (!_ContentStore["default"].isContentStore(contentStore)) {
      throw new Error('contentStore must be of type ContentStore');
    }

    var canvasDimensionsOption = renderOptions.canvasDimensions,
        canvasImageSmoothing = renderOptions.canvasImageSmoothing,
        _renderOptions$filter = renderOptions.filterProcessor,
        filterProcessor = _renderOptions$filter === void 0 ? new _ContextFilterProcessor["default"]() : _renderOptions$filter,
        _renderOptions$layerR = renderOptions.layerRendererCache,
        layerRendererCache = _renderOptions$layerR === void 0 ? new _LayerRendererCache["default"]() : _renderOptions$layerR,
        rootCanvas = renderOptions.rootCanvas;

    var isValidCanvasDimensions = _Rectangle["default"].isValidRectangle(canvasDimensionsOption);

    var canvasHeight = isValidCanvasDimensions ? canvasDimensionsOption.height : creative.height;
    var canvasWidth = isValidCanvasDimensions ? canvasDimensionsOption.width : creative.width; // We use these canvas dimensions to set the width/height of the root canvas

    var canvasDimensions = new _Rectangle["default"](0, 0, canvasWidth, canvasHeight); // We use these creative dimensions to draw the fullness of the creative as the given width/height

    var creativeDimensions = new _Rectangle["default"](0, 0, creative.width, creative.height); // Create a layer transformer

    var layerTransformer = new _LayerTransformer["default"](creativeDimensions, canvasFactory, canvasImageSmoothing); // Call super

    _this = _super.call(this, null, contentStore, layerTransformer, filterProcessor, layerRendererCache, canvasFactory, {
      dimensions: creativeDimensions,
      imageSmoothing: canvasImageSmoothing
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_backgroundCanvas", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_backgroundCanvasDimensions", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_backgroundContext", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_creative", null);
    _this._creative = creative;
    _this._layerTransformData = _this._getRootCanvasLayerData();

    if ((0, _isNotNil["default"])(rootCanvas)) {
      rootCanvas.height = canvasHeight;
      rootCanvas.width = canvasWidth;
    } // Create separate canvas context for background color


    var canvas = rootCanvas || canvasFactory.getCanvas({
      height: canvasHeight,
      width: canvasWidth
    });
    var context = canvas.getContext('2d');
    _this._backgroundCanvas = canvas;
    _this._backgroundCanvasDimensions = canvasDimensions;
    _this._backgroundContext = context;
    (0, _canvas.setImageSmoothing)(_this._backgroundContext, canvasImageSmoothing); // Translate draw insertion point over to center point

    _this.updateTransform();

    _this.clearAll();

    return _this;
  }

  (0, _createClass2["default"])(RootRenderer, [{
    key: "clearAll",

    /*
     Override clearAll so that it also draws in the background fill for the root layer
     */
    value: function clearAll() {
      /*
      Assumes the current context is translated correctly as per the constructor
       */
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(RootRenderer.prototype), "clearAll", this).call(this);
      var _this$_groupDimension = this._groupDimensions,
          canvasHeight = _this$_groupDimension.height,
          canvasWidth = _this$_groupDimension.width;

      this._backgroundContext.clearRect(0, 0, canvasWidth, canvasHeight);

      this._drawBackgroundFill();
    }
    /*
     Update Transform to the current width and height
     */

  }, {
    key: "updateTransform",
    value: function updateTransform() {
      if ((0, _isNil["default"])(this._backgroundContext)) {
        throw new Error('RootRenderer.updateTransform context is nil.');
      }

      var _this$_creative = this._creative,
          height = _this$_creative.height,
          width = _this$_creative.width;
      var _this$_backgroundCanv = this._backgroundCanvasDimensions,
          canvasHeight = _this$_backgroundCanv.height,
          canvasWidth = _this$_backgroundCanv.width; // Translate draw insertion point over to center point

      (0, _setContextTransform["default"])(this._backgroundContext, -canvasWidth / 2, -canvasHeight / 2, canvasWidth / width, canvasHeight / height, 0, this._backgroundCanvasDimensions);
    }
  }, {
    key: "_calculateLayerTransformData",
    value: function _calculateLayerTransformData(frameNum) {
      // eslint-disable-line no-unused-vars
      return this._layerTransformData;
    }
  }, {
    key: "_drawBackgroundFill",
    value: function _drawBackgroundFill() {
      /*
      Assumes the current context is translated correctly as per the constructor
       */
      var _this$_creative2 = this._creative,
          backgroundAlpha = _this$_creative2.backgroundAlpha,
          backgroundColor = _this$_creative2.backgroundColor;
      var _this$_groupDimension2 = this._groupDimensions,
          canvasHeight = _this$_groupDimension2.height,
          canvasWidth = _this$_groupDimension2.width;
      this._backgroundContext.globalAlpha = backgroundAlpha;
      this._backgroundContext.fillStyle = backgroundColor;

      this._backgroundContext.fillRect(0, 0, canvasWidth, canvasHeight);

      this._backgroundContext.globalAlpha = 1; // Reset to avoid future drawing issues
    }
  }, {
    key: "_drawEmptyCanvas",
    value: function _drawEmptyCanvas(canvasContext) {
      if (!canvasContext) {
        return;
      }

      this.clearAll();

      this._drawBackgroundFill();
    }
    /*
     Override element id list, getting elements that are currently visible on the root and filtering out AUDIO.
     */

  }, {
    key: "_getChildLayers",
    value: function _getChildLayers() {
      if (this._creative.isEmpty()) return [];
      var _this$_creative3 = this._creative,
          layersById = _this$_creative3.layersById,
          rootElementIds = _this$_creative3.rootElementIds;
      var rootLayers = new Map();
      rootElementIds.forEach(function (elementId) {
        var layer = layersById.get(elementId);
        if (!_CreativeLayer["default"].isCreativeLayer(layer)) return;
        if (!layer.loaded || !_CreativeLayer["default"].isVisibleCreativeLayer(layer)) return;
        rootLayers.set(elementId, layer);
      });
      return rootLayers;
    }
  }, {
    key: "_getRootCanvasLayerData",
    value: function _getRootCanvasLayerData() {
      var _this$_groupDimension3 = this._groupDimensions,
          canvasHeight = _this$_groupDimension3.height,
          canvasWidth = _this$_groupDimension3.width;
      return new _LayerTransformData["default"](_BaseRenderer["default"].DERIVED_DIMENSIONS,
      /* contentX */
      0,
      /* contentY */
      0, canvasWidth, canvasHeight,
      /* contentScaleX */
      null,
      /* contentScaleY */
      null,
      /* alpha */
      null,
      /* rotation */
      null,
      /* scale */
      null,
      /* translation */
      null, _creative.DEFAULT_ALPHA_BLEND_MODE,
      /* visible */
      true, _creative.DEFAULT_KEYFRAME_TRANSFORM.filters);
    }
  }, {
    key: "drawLayerAtFrame",
    value: function drawLayerAtFrame(canvasContext, currentFrame, contentFrameData, layerTransformData) {
      if ((0, _isNil["default"])(canvasContext)) return;

      if (this._creative.isEmpty()) {
        this._drawEmptyCanvas(canvasContext);
      } else {
        // Return the bitmap data from regular group drawing
        (0, _get2["default"])((0, _getPrototypeOf2["default"])(RootRenderer.prototype), "drawLayerAtFrame", this).call(this, canvasContext, currentFrame, contentFrameData, layerTransformData);
      }
    }
  }, {
    key: "getRootBitmap",
    value: function getRootBitmap(currentFrame) {
      if (this.shouldDrawNewFrame(currentFrame)) {
        this.renderLayer(this._backgroundContext, currentFrame, this._groupDimensions);
      }

      return this._backgroundCanvas;
    }
  }, {
    key: "creative",
    set: function set(value) {
      this._creative = value;
      this._hasRendered = false; // TODO temporary fix for needed shouldDrawNewFrame update
    }
  }]);
  return RootRenderer;
}(_GroupRenderer2["default"]);

exports["default"] = RootRenderer;